import { LOB, PLAN_TYPES } from "@/config/constants";
import { createSlice, current } from "@reduxjs/toolkit";

const ERROR_INITIAL = {
  hasError: false,
  error: "",
};
const initialState = {
  productName: "BOLT-PA",
  members: [],
  payloadPA: {
    lob: LOB.PA || "pa",
    businessType: "New Business",
    // prevPolicyEndDate: "",
    portability: false,
    planType: PLAN_TYPES.INDIVIDUAL,
    tenure: 1,
    typeOfProduct: "Retail",
    isEmployee: false,
    goGreen: false,
    solId: "s123",
    source: "",
    producerCode: "",
    ipAddress: "1.2.3.4",
    isExistingCustomer: false,
    branchLocation: "",
    loginEmail: "",
    proposer: {
      address: {
        pincode: "",
      },
      occupation: "",
      annualIncome: 0,
    },

    memberDetails: [],
  },
  externalPOSP: false,
  quoteAdditionalInfo: {
    pincode: "",
    city: "",
    state: "",
    sumInsured: "",
    tenure: "",
  },
  documentReferenceId: "",
  quoteNo: "",
  cloneMembersDob: {},
  quoteDetails: { sumInsured: 500000, tenure: 1 },
  membersDobForm: {},
  error: ERROR_INITIAL,
  PDPerror: ERROR_INITIAL,
  applyNowPaPDP: false,
  bancaShow: true,
  quoteData: {},
  loanDetails: {},
  requiredLoanDetails: [],
  loanData: {},
  isExistingLoanShield: false,
  selectedQuote: {},
  addOnsForPackages: {},
  bancaFields: {},
  isClone: false,
  pdpData: {},
  rejectedMembers: [],
  sumInsuredOneCr: [],
  salariedMembers: [],
};

export const quoteSlicePa = createSlice({
  name: "quotePa",
  initialState,
  reducers: {
    setMemberDataPA: (state, action) => {
      state.members = action.payload;
    },
    setMemberDobDataClonePA: (state, action) => {
      state.cloneMembersDob = action.payload;
    },
    clearQuoteDataPA: () => {
      return initialState;
    },
    setQuoteErrorPA: (state, action) => {
      state.error = action.payload;
    },
    setQuotePayloadPA: (state, action) => {
      state.payloadPA = action.payload;
    },
    setQuoteFormDataPA: (state, action) => {
      state.membersDobForm = action.payload;
    },
    setApplyNowPaPDP: (state, action) => {
      state.applyNowPaPDP = action.payload;
    },
    setIsEmployeePA: (state, action) => {
      state.isEmployee = action.payload;
    },
    setQuoteNoPA: (state, action) => {
      state.quoteNo = action.payload;
    },
    setQuoteAdditionalInfoDataPA: (state, action) => {
      state.quoteAdditionalInfo = {
        ...state.quoteAdditionalInfo,
        ...action.payload,
      };
    },
    setShowBancaPA: (state, action) => {
      state.showBanca = action.payload;
    },
    setPospPA: (state, action) => {
      state.externalPOSP = action.payload;
    },
    setQuoteDataPA: (state, action) => {
      state.quoteData = action.payload;
    },
    setLoanDetailsPA: (state, action) => {
      state.loanDetails = action.payload;
    },
    setRequiredLoanDetailsPA: (state, action) => {
      state.requiredLoanDetails = action.payload;
    },
    setSelectedQuotePA: (state, action) => {
      state.selectedQuote = action.payload;
    },
    setPackageAddOnsPA: (state, action) => {
      state.addOnsForPackages = action.payload;
    },
    setBancaFieldsPA: (state, action) => {
      state.bancaFields = action.payload;
    },
    setPDPErrorPA: (state, action) => {
      state.PDPerror = action.payload;
    },
    setIsClonePA: (state, action) => {
      state.isClone = action.payload;
    },
    setLoanDataPA: (state, action) => {
      state.loanData = action.payload;
    },
    setIsExistingLoanShieldPA: (state, action) => {
      state.isExistingLoanShield = action.payload;
    },
    setQuoteDetailsPA: (state, action) => {
      state.quoteDetails = action.payload;
    },
    setPdpData: (state, action) => {
      state.pdpData = action.payload;
    },
    setRejectedMembers: (state, action) => {
      state.rejectedMembers = action.payload;
    },
    setSumInsuredOneCr: (state, action) => {
      state.sumInsuredOneCr = action.payload;
    },
    setSalariedMembers: (state, action) => {
      state.salariedMembers = action.payload;
    },
  },
});

export const {
  setMemberDataPA,
  setQuoteErrorPA,
  setQuotePayloadPA,
  setQuoteFormDataPA,
  setApplyNowPaPDP,
  setIsEmployeePA,
  setQuoteNoPA,
  setQuoteAdditionalInfoDataPA,
  setShowBancaPA,
  setPospPA,
  setQuoteDataPA,
  setLoanDetailsPA,
  setRequiredLoanDetailsPA,
  setSelectedQuotePA,
  setPackageAddOnsPA,
  setBancaFieldsPA,
  setPDPErrorPA,
  setIsClonePA,
  setLoanDataPA,
  setIsExistingLoanShieldPA,
  setMemberDobDataPA,
  setQuoteDetailsPA,
  setMemberDobDataClonePA,
  clearQuoteDataPA,
  setPdpData,
  setRejectedMembers,
  setSumInsuredOneCr,
  setSalariedMembers,
} = quoteSlicePa.actions;
export const getMembersPA = (state) => state.quotePa?.members;
export const getQuoteErrorPA = (state) => state.quotePa?.error;
export const getQuotePayloadPA = (state) => state.quotePa?.payloadPA;
export const getQuoteDetailsPA = (state) => state.quotePa?.quoteDetails;
export const getCloneMembersDobPA = (state) => state.quotePa?.cloneMembersDob;
export const getQuoteFormData = (state) => state.quotePa?.membersDobForm;
export const getApplyNowPaPDP = (state) => state.quotePa?.applyNowPaPDP;
export const getIsEmployeePA = (state) => state.quotePa?.isEmployee;
export const getQuoteNoPA = (state) => state.quotePa?.quoteNo;
export const getQuoteAdditionalInfoDataPA = (state) =>
  state.quotePa?.quoteAdditionalInfo;
export const getShowBancaPA = (state) => state.quotePa.showBanca;
export const getExternalPOSPPA = (state) => state.quotePa.externalPOSP;
export const getQuoteDataPA = (state) => state.quotePa.quoteData;
export const getPackageAddOnsPA = (state) => state?.quotePa?.addOnsForPackages;
export const getSelectedQuotePA = (state) => state?.quotePa?.selectedQuote;
export const getLoanDetailsPA = (state) => state.quotePa?.loanDetails;
export const getRequiredLoanDetailsPA = (state) =>
  state.quotePa?.requiredLoanDetails;
export const getBancaFieldsPA = (state) => state.quotePa.bancaFields;
export const getPDPErrorPA = (state) => state.quotePa?.PDPerror;
export const getIsClonePA = (state) => state.quotePa.isClone;
export const getLoanDataPA = (state) => state.quotePa.loanData;
export const getIsExistingLoanShieldPA = (state) =>
  state.quotePa?.isExistingLoanShield;
export const getPdpData = (state) => state?.quotePa?.pdpData;
export const getRejectedMembers = (state) => state?.quotePa?.rejectedMembers;
export const getSumInsuredOneCr = (state) =>
  state.quotePa?.sumInsuredOneCr || [];
export const getSalariedMembers = (state) => state?.quotePa?.salariedMembers;

export default quoteSlicePa.reducer;
